import { UserSession, useUserSession } from '@jusbrasil-web/shared-user-session'
import { useRef } from 'react'

import { GTMDataLayer, GTMDataLayerCustomValues } from '../../types'

/**
 * Pure builder for the initial GTM dataLayer object.
 *
 * Exposed so that server-side renderers (e.g. `pages/_document.tsx`) can
 * produce the *exact same* dataLayer shape as the client-side
 * {@link useGTMDataLayer} hook, without depending on React context.
 */
export function buildGTMDataLayer(
  session: UserSession | null | undefined,
  customValues: GTMDataLayerCustomValues
): GTMDataLayer {
  const dataLayer: GTMDataLayer = {
    environment: process.env.NODE_ENV,
    enable_google_analytics: true,
    cookie_domain: 'jusbrasil.com.br',
    argos_enabled: true,
    disable_react_relay: true,
  }

  const optionalValues = Object.entries({
    ...customValues,
    'user.device_id': session?.jdid,
    'user.pid': session?.pid,
    'experiment.name': session?.experiment?.name,
    'experiment.variation': session?.experiment?.alternative,
  })

  optionalValues.forEach(([key, value]) => {
    if (value !== undefined) {
      dataLayer[key] = value
    }
  })

  return dataLayer
}

export function useGTMDataLayer(customValues: GTMDataLayerCustomValues): GTMDataLayer {
  const session = useUserSession()
  return useRef(buildGTMDataLayer(session, customValues)).current
}
